import React from 'react';

import AsyncCreatableSelect from 'react-select/async-creatable';
import { updateSalesforceUserTags } from 'Shared/actions/organizations';
import { useDispatch } from 'react-redux';

type Props = {
  tags;
  tagOptions;
  userId;
};

function SalesforceUserTagArea({ tags, tagOptions, userId }: Props) {
  const dispatch = useDispatch();
  const handleCreateTag = value => {
    dispatch(updateSalesforceUserTags({ tags: [value, ...tags.map(({ label }) => label)], userId }));
  };
  const handleChange = value => {
    dispatch(updateSalesforceUserTags({ tags: (value || []).map(({ label }) => label), userId }));
  };
  return (
    <AsyncCreatableSelect
      onChange={handleChange}
      onCreateOption={handleCreateTag}
      value={tags}
      defaultOptions={tagOptions}
      isMulti
      isValidNewOption={inputValue => {
        const isNotDuplicated = !tagOptions.map(option => option.label).includes(inputValue);
        const isNotEmpty = inputValue !== '';
        return isNotEmpty && isNotDuplicated;
      }}
      isClearable={false}
    />
  );
}

export default SalesforceUserTagArea;
